import React from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as RequiredIcon} from '../../../assets/images/icon-required.svg';
import IconButtonSwitch from './IconButtonSwitch';
import styles from './RequiredButtonSwitch.module.scss';

interface Props {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  value?: boolean;
}

const RequiredButtonSwitch = ({ onClick, value}: Props): React.ReactElement => {

  const {t} = useTranslation();
  const tooltip = t('COMMON.TOOLTIPS.MARK_AS_REQUIRED');

  return (
    <IconButtonSwitch
      className={styles.button}
      icon={<RequiredIcon />}
      onClick={onClick}
      value={value}
      ariaLabel={tooltip}
      tooltipTitle={tooltip}
    />
  );
}

export default RequiredButtonSwitch;
